<template>
  <login-layout :title="$t('Accedi alla Webmail')">
    <pf-form :action="webmail" method="post" :aria-disabled="!webmail">
      <pf-form-group :name="$t('Casella Email')">
        <x-input
          id="webmailEmail"
          v-model="email"
          name="user"
          type="email"
          placeholder="Email"
          required
          autocomplete="username"
        />
      </pf-form-group>

      <pf-form-group :name="$t('Password')">
        <x-input
          id="webmailPassword"
          name="pass"
          type="password"
          :placeholder="$t('Password')"
          autocomplete="current-password"
        />
      </pf-form-group>

      <pf-action-group>
        <pf-button :disabled="!webmail" type="submit" variant="primary" large block>{{ $t('Log In') }}</pf-button>
      </pf-action-group>
    </pf-form>

    <div class="separator">
      <pf-title h="1">{{ $t('Posta certificata (PEC)') }}</pf-title>

      <pf-button :href="webmailUrl" target="_blank" icon-position="end" large block class="pf-v6-u-mt-md">
        <template #icon>
          <arrow-up-right-from-square-icon />
        </template>
        {{ $t('Accedi') }}
      </pf-button>
    </div>

    <template #forgot-credentials>
      {{ $t("Vuoi accedere all'area riservata?") }}
      <router-link :to="{ name: 'login' }">{{ $t('Log In') }}</router-link>
    </template>
  </login-layout>
</template>

<style scoped>
.separator::before {
  display: block;
  content: "";
  width: 50%;
  margin: 20px auto;
  border-top: 1px solid #bbb;
}
</style>

<script lang="ts" setup>
import ArrowUpRightFromSquareIcon from '@vue-patternfly/icons/arrow-up-right-from-square-icon';
import LoginLayout from '@/components/login-layout.vue';
import { computed, ref } from 'vue';

defineOptions({
  name: 'WebmailPage',
});

const email = ref('');

const webmail = computed(() => {
  const m = (/.@([^\s]+\.[^\s]+)$/).exec(email.value);
  if (!m || !m[1]) {
    return;
  }
  return `https://mail.${m[1]}:2096/login/`;
});

// URL fuori dal template: vue-tsc 3.3.13 interpreta il // delle URL nelle prop come commento (vuejs/language-tools#6240)
const webmailUrl = 'https://mail.arterapec.it/';
</script>
